import { rest } from 'msw'

export const handlers = [
  rest.post('enter-mock-api-here', (req, res, ctx) => {
    return res(ctx.status(503), ctx.json({}))
  })
]
